// extracted by mini-css-extract-plugin
module.exports = {"Button":"BENavBarProfileDropdown_Button__1OeL0","DropDown":"BENavBarProfileDropdown_DropDown__1yacf","DropdownItem":"BENavBarProfileDropdown_DropdownItem__17Q_V"};